import { Component } from "react";

import { ValueDisplay } from "commonComponents/utilities/ValueDisplay/ValueDisplay";

interface INotificationPreferencesHeaderProps {}

export class NotificationPreferencesHeader extends Component<INotificationPreferencesHeaderProps> {
    private getNotificationLabel() {
        if ("Notification" in window && Notification.permission === "granted") {
            return "Browser notifications are turned on. To stop receiving browser notifications, go to your browser settings and choose to block notifications from Buildertrend.net.";
        } else {
            return "Browser notifications are turned off. To start receiving browser notifications, go to your browser settings and choose to allow notifications from Buildertrend.net.";
        }
    }

    render() {
        return <ValueDisplay value={this.getNotificationLabel()} />;
    }
}
